import { locationKind } from "../../../location/location-kind.const";

export const locationSelectDefaultOptions = [
  locationKind.port,
  locationKind.airport,
  locationKind.railTerminal,
  locationKind.roadTerminal,
];
